import { render, staticRenderFns } from "./privilegeGoods_norms.vue?vue&type=template&id=6d8e362f&scoped=true&"
import script from "./privilegeGoods_norms.vue?vue&type=script&lang=js&"
export * from "./privilegeGoods_norms.vue?vue&type=script&lang=js&"
import style0 from "./privilegeGoods_norms.vue?vue&type=style&index=0&id=6d8e362f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d8e362f",
  null
  
)

export default component.exports